/** Get increase or decrease points in a row. 
This is used for getting a pick up points */
export function getChangeStsList(startSts: number, endSts: number): number[] {
  const diff = Math.abs(endSts - startSts);
  const everyXsts = Array(diff).fill(startSts / diff);
  everyXsts.forEach((val, i) => {
    const rounded = Math.round(val);
    const diff = rounded - val;
    everyXsts[i] = rounded;
    if (i < everyXsts.length - 1) {
      everyXsts[i + 1] -= diff;
    }
  });
  return everyXsts;
}

// For 2 sts dec, merge two stitch groups into one
export function getDec2StsList(startSts: number, endSts: number): number[] {
  const dec1List = getChangeStsList(startSts, endSts);
  return dec1List.reduce((agg: number[], cur, i) => {
    if (i % 2 === 0) {
      agg.push(cur);
    } else {
      agg[agg.length - 1] += cur;
    }
    return agg;
  }, []);
}
